var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 overflow-scroll"},[(_vm.$store.state.ifAdmin)?_c('dataBoard'):_c('div',{staticClass:"flipBox"},[_c('flip-clock')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }